import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable, firstValueFrom} from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TableSummaryService {

  // @ts-ignore
  private _products$ = new BehaviorSubject<table[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  get products$() { return this._products$.asObservable(); }
  get total$() { return this._total$.asObservable(); }
  page = 1;
  pageSize = 10

  constructor(private http: HttpClient) {
  }

  getReceiptTemplate(): Observable<string> {
    return this.http.get('/assets/templates/HtmlComprovantePix.html', { responseType: 'text' });
  }

  getBankProvider(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/bankProvider`)
    }
  
  getAccount() : Promise<any>{
    return firstValueFrom(this.http.get(`${environment.apiUrl}/account`));
  }

  getTransactionDetail(id: string): Promise<any> {
    return firstValueFrom(
      this.http.get(`${environment.apiUrl}/gettransactiondetail`, {
        params: { id }            
      })
    );
  }

}
